export const RESULTS_CHIP_TYPES = {
	FAILED_BIDS: 'Failed bids',
	SUCCESSFUL_BIDS: 'Successful bids',
} as const;

export type ResultChipType = (typeof RESULTS_CHIP_TYPES)[keyof typeof RESULTS_CHIP_TYPES];

export const BIDS_AND_OFFERS_LINK_LOCATION = {
	RESULTS_PAGE: 'Results page',
	SUCCESS_TOAST: 'Success toast',
} as const;

export type BidsAndOffersLinkLocation =
	(typeof BIDS_AND_OFFERS_LINK_LOCATION)[keyof typeof BIDS_AND_OFFERS_LINK_LOCATION];
